module.exports = __webpack_public_path__ + "49eae836.png";